
import { CheckCircle } from 'lucide-react';

const PaymentSuccessHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="rounded-full bg-green-100 p-3 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
        <CheckCircle className="h-10 w-10 text-green-600" />
      </div>
      <h1 className="text-3xl font-bold text-gray-900">Payment Successful!</h1>
      <p className="text-gray-600 mt-2">
        Thank you for your purchase. Your payment has been confirmed.
      </p>
    </div>
  );
};

export default PaymentSuccessHeader;
